import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { fmtCurrency } from "../../lib/format";

export default function SnapshotCard({ agg, m, currency }) {
  return (
    <Card className="lg:col-span-4 bg-white border-[#E5E0D8] shadow-none" data-testid="snapshot-card">
      <CardHeader className="pb-2">
        <CardDescription className="text-xs uppercase tracking-[0.18em] text-[#5C665D]">Snapshot</CardDescription>
        <CardTitle className="font-serif-display text-2xl text-[#1F382E]">The numbers, at a glance.</CardTitle>
      </CardHeader>
      <CardContent className="grid grid-cols-2 gap-4 pt-3">
        <SnapshotRow label="Revenue" value={fmtCurrency(agg.revenue, currency)} />
        <SnapshotRow label="EBITDA" value={fmtCurrency(m.ebitda, currency)} />
        <SnapshotRow label="Net Income" value={fmtCurrency(m.net_income, currency)} />
        <SnapshotRow label="Total Assets" value={fmtCurrency(agg.total_assets, currency)} />
        <SnapshotRow label="Total Debt" value={fmtCurrency(agg.total_debt, currency)} />
        <SnapshotRow label="Equity" value={fmtCurrency(agg.total_equity, currency)} />
        <SnapshotRow label="Operating CF" value={fmtCurrency(m.operating_cash_flow, currency)} />
        <SnapshotRow label="Free Cash Flow" value={fmtCurrency(m.free_cash_flow, currency)} />
      </CardContent>
    </Card>
  );
}

function SnapshotRow({ label, value }) {
  return (
    <div>
      <p className="text-[11px] uppercase tracking-[0.16em] text-[#5C665D]">{label}</p>
      <p className="font-serif-display text-xl text-[#1F382E] tabular-nums">{value}</p>
    </div>
  );
}
